import { operateMaxShowLength } from '@/store/dict/config'
import selectOption from '@/store/dict/selectOptionDict'

export default {
  data() {
    return {
      m_receiptListHead: [
        {
          name: 'id',
          columnProps: {
            label: '收款单ID',
            prop: 'id',
            width: 100,
          },
          render: ({ row }) => {
            if (!this.judgePermission('finance_receivable_receipt_detail')) return row.id
            return (
                <span class="a-hover-link" onClick={() => this.viewDetails(row.id)}>{row.id}</span>
            )
          },
        },
        {
          name: 'receivableId',
          columnProps: {
            label: '应收ID',
            prop: 'receivableId',
          },
        },
        {
          name: 'plateNo',
          columnProps: {
            label: '车牌号',
            prop: 'plateNo',
            width: 100,
          },
        },
        {
          name: 'content',
          columnProps: {
            label: '收款内容',
            prop: 'content',
          },
          getText: ({ row }) => {
            if (this.freeTypeList.find((item) => item.code === row.content)) {
              return this.freeTypeList.find((item) => item.code === row.content).name
            }
          },
        },
        {
          name: 'amount',
          columnProps: {
            label: '收款金额(元)',
            prop: 'amount',
            width: 100,
          },
          getText: ({ row }) => this.numberWithCommas(row.amount),
        },
        {
          name: 'tenantAmount',
          columnProps: {
            label: '到账金额(元)',
            prop: 'tenantAmount',
            width: 100,
          },
          getText: ({ row }) => this.numberWithCommas(row.tenantAmount),
        },
        {
          name: 'payFee',
          columnProps: {
            label: '支付手续费(元)',
            prop: 'payFee',
            width: 130,
          },
          getText: ({ row }) => (row.payFee === null ? '--' : this.numberWithCommas(row.payFee)),
        },
        {
          name: 'commissionAmount',
          columnProps: {
            label: '乾三佣金(元)',
            prop: 'commissionAmount',
            width: 110,
          },
          getText: ({ row }) => (row.commissionAmount === null ? '--' : this.numberWithCommas(row.commissionAmount)),
        },
        {
          name: 'feePayerDesc',
          columnProps: {
            label: '支付手续费承担方',
            prop: 'feePayerDesc',
            width: 140,
          },
        },
        {
          name: 'payMethodName',
          columnProps: {
            label: '支付方式',
            prop: 'payMethodName',
            width: 140,
          },
        },
        {
          name: 'customerType',
          columnProps: {
            label: '付款方类型',
            prop: 'customerType',
            width: 100,
          },
          getText: ({ row }) => selectOption.customerTypeDict[row.customerType],
        },
        {
          name: 'customerName',
          columnProps: {
            label: '付款方',
            prop: 'customerName',
            width: 160,
          },
        },
        {
          name: 'customerId',
          columnProps: {
            label: '付款方ID',
            prop: 'customerId',
          },
        },
        {
          name: 'payer',
          columnProps: {
            label: '客户名称',
            prop: 'payer',
            width: 110,
          },
        },
        {
          name: 'spName',
          columnProps: {
            label: '关联网约平台',
            prop: 'spName',
            width: 110,
          },
        },
        {
          name: 'merchantName',
          columnProps: {
            label: '收款主体',
            prop: 'merchantName',
            width: 110,
          },
        },
        {
          name: 'state',
          columnProps: {
            label: '收款单状态',
            prop: 'state',
            width: 100,
          },
          getText: ({ row }) => selectOption.moneyStateList[row.state],
        },
        {
          name: 'batchReceivableId',
          columnProps: {
            label: '收款ID',
            prop: 'batchReceivableId',
            width: 100,
          },
        },
        {
          name: 'gmtCreate',
          columnProps: {
            label: '创建时间',
            prop: 'gmtCreate',
            width: 100,
          },
        },
        {
          name: 'completeTime',
          columnProps: {
            label: '完成时间',
            prop: 'completeTime',
            width: 100,
          },
        },
        {
          name: 'discardTime',
          columnProps: {
            label: '作废时间',
            prop: 'discardTime',
            width: 100,
          },
        },
        {
          name: 'discardReason',
          columnProps: {
            label: '作废原因',
            prop: 'discardReason',
          },
        },
        {
          name: 'deptName',
          columnProps: {
            label: '所属部门',
            prop: 'deptName',
          },
        },
        {
          name: 'operate',
          columnProps: {
            label: '操作',
            width: 240,
            fixed: 'right',
          },
          maxShowLength: operateMaxShowLength,
          type: 'operate',
          getOperateList: ({ row }) => {
            const result = [
              {
                name: 'cancel',
                label: '作废',
                // 10-线下单
                permission: Number(row.state) === 1 && !row.batchReceivableId && Number(row.payMethod) === 10 && this.judgePermission('finance_receivable_receipt_cancel'),
                action: () => this.handleInvalid(row),
              },
            ]
            return result.filter((i) => i.permission)
          },
        },
      ],
    }
  },
}
